import React, { useState } from 'react';
const FAQS = [{
  q: '📦 ¿Qué es "La Biblia del Café"?',
  a: 'Es una guía digital que te enseña el Método BÍBLICO™ para dominar el café consistente en casa.'
}, {
  q: '📥 ¿Cómo recibo el contenido?',
  a: '¡Inmediatamente! Acceso instantáneo por email y WhatsApp.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-[30px] px-[15px] bg-[#F9F5F0]" data-id="element-95">
      <div className="container max-w-[500px] mx-auto px-[15px]" data-id="element-96">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-97">
          🤔 Preguntas Frecuentes
        </h2>

        {FAQS.map((faq, index) => <div key={index} className="mb-[12px] rounded-[8px] overflow-hidden shadow-[0_4px_10px_rgba(0,0,0,0.05)] bg-white" data-id="element-98">
            <div className={`p-[15px] font-[700] text-[16px] cursor-pointer relative ${openIndex === index ? 'active' : ''}`} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-99">
              {faq.q}
              <span className="absolute right-[15px] text-[22px] text-[#8B4513]" data-id="element-100">
                {openIndex === index ? '-' : '+'}
              </span>
            </div>
            <div className={`px-[15px] overflow-hidden transition-[max-height] duration-300 ease-in-out ${openIndex === index ? 'max-h-[200px]' : 'max-h-0'}`} data-id="element-101">
              <div className="py-[15px] text-[#374151]" data-id="element-102">
                <p data-id="element-103">{faq.a}</p>
              </div>
            </div>
          </div>)}

        <a className="block w-full bg-gradient-to-br from-[#8B4513] to-[#A0522D] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(139,69,19,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(139,69,19,0.5)] transition-all duration-400 mt-[20px]" href="#elige-tu-plan" data-id="element-104">
          Descargar La Biblia del Café
        </a>
      </div>
    </section>;
}